function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
// Imports
import Error from '@engine/components/presentational/base/error';
import Loader from '@engine/components/presentational/base/loader';
import Panel from '@engine/components/presentational/base/panel';
import React from 'react';
import RiskFilterSettingsFields from '@engine/components/presentational/risk-filter-settings-fields';

var RiskFilterSettingsBaseForm = /*#__PURE__*/function (_React$Component) {
  _inherits(RiskFilterSettingsBaseForm, _React$Component);

  var _super = _createSuper(RiskFilterSettingsBaseForm);

  function RiskFilterSettingsBaseForm() {
    _classCallCheck(this, RiskFilterSettingsBaseForm);

    return _super.apply(this, arguments);
  }

  _createClass(RiskFilterSettingsBaseForm, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-lg-12"
      }, React.createElement(Panel.Container, null, React.createElement(Panel.Header, null, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-lg-3 col-md-3 col-sm-3 col-xs-3"
      }), React.createElement("div", {
        className: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
      }, React.createElement("h4", {
        className: "mt-0 mb-0 text-center"
      }, " ", this.props.formTitle, " ")))), React.createElement(Panel.Body, null, this.props.formIsLoading ? React.createElement(Loader, {
        message: this.props.formLoadingMessage,
        position: "horizontal-center",
        color: "refined-blue"
      }) : React.createElement(RiskFilterSettingsFields, {
        defaultSettings: this.props.defaultSettings,
        currentSettings: this.props.currentSettings,
        filterClass: this.props.filterClass,
        onSettingChange: this.props.onSettingChange
      })), React.createElement(Panel.Footer, null, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
      }, this.props.formSaveFailed ? React.createElement(Error, null, this.formErrorMessage) : ''), React.createElement("div", {
        className: "col-lg-4 col-lg-offset-4 col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4"
      }, this.props.formIsSaving ? React.createElement(Loader, {
        message: this.props.formSavingMessage,
        position: "horizontal-center",
        color: "refined-blue"
      }) : '', !this.props.formIsSaving && !this.props.formIsSaved ? React.createElement("input", {
        type: "submit",
        value: this.props.submitButtonText,
        className: "btn btn-success btn-block",
        onClick: this.props.onSubmit
      }) : '', this.props.formIsSaved ? React.createElement(Loader, {
        message: this.props.formSavedMessage,
        position: "horizontal-center",
        color: "refined-green",
        icon: "ok"
      }) : '', this.props.formIsSaved ? this.redirect() : ''))))));
    }
  }, {
    key: "redirect",
    value: function redirect() {
      window.location.replace(this.props.redirectUrl);
    }
  }, {
    key: "formErrorMessage",
    get: function get() {
      return this.props.formFailedMessage ? this.props.formFailedMessage : "".concat(I18n.t('javascript.errors.unable_to_process_request'), "\n         ").concat(I18n.t('javascript.errors.try_again_later'));
    }
  }]);

  return RiskFilterSettingsBaseForm;
}(React.Component);

export default RiskFilterSettingsBaseForm;